import React from 'react';
import { XCircle, Map } from 'lucide-react';
export function TruthSection() {
  return <section className="py-12 bg-warm-100" data-id="element-203">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-204">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-205">
          <h2 className="text-3xl md:text-4xl font-bold text-warm-900 mb-6" data-id="element-206">
            La verdad incómoda: <br data-id="element-207" />
            <span className="text-rose-600" data-id="element-208">
              No eres tú, es el mapa que te dieron
            </span>
          </h2>
          <p className="text-lg text-warm-700" data-id="element-209">
            No es que seas floja. No es que seas tonta. El problema es que el
            90% de lo que ves sobre "ganar dinero en internet" está hecho para
            otra realidad.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-210">
          {/* The Wrong Map */}
          <div className="bg-white p-8 rounded-2xl shadow-sm" data-id="element-211">
            <h3 className="text-xl font-bold text-warm-900 mb-6 flex items-center gap-2" data-id="element-212">
              <XCircle className="text-red-400" data-id="element-213" />
              Lo que te han vendido
            </h3>
            <ul className="space-y-4" data-id="element-214">
              {['OnlyFans y cosas que no van contigo', 'Trading, criptos y apuestas tipo casino', 'Cursos en dólares impagables', 'Estrategias para USA o Europa', 'Exigencia de inglés perfecto'].map((item, i) => <li key={i} className="flex items-start gap-3 text-warm-600" data-id="element-215">
                  <span className="text-red-300 mt-1" data-id="element-216">✕</span>
                  {item}
                </li>)}
            </ul>
          </div>

          {/* The Reality Check */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-l-4 border-rose-400" data-id="element-217">
            <h3 className="text-xl font-bold text-warm-900 mb-6 flex items-center gap-2" data-id="element-218">
              <Map className="text-rose-500" data-id="element-219" />
              Lo que realmente pasa
            </h3>
            <p className="text-warm-700 mb-4" data-id="element-220">
              Muchos cursos asumen que tienes 4-6 horas libres al día. Te dicen
              "si quieres, puedes", pero nunca te muestran:
            </p>
            <ul className="space-y-3 font-medium text-warm-800" data-id="element-221">
              <li className="flex items-center gap-2" data-id="element-222">
                <span className="w-1.5 h-1.5 bg-rose-400 rounded-full" data-id="element-223"></span>
                Qué mensaje mandar exactamente
              </li>
              <li className="flex items-center gap-2" data-id="element-224">
                <span className="w-1.5 h-1.5 bg-rose-400 rounded-full" data-id="element-225"></span>A
                quién escribirle
              </li>
              <li className="flex items-center gap-2" data-id="element-226">
                <span className="w-1.5 h-1.5 bg-rose-400 rounded-full" data-id="element-227"></span>
                Cuánto cobrar en pesos mexicanos
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}